import { render } from "./lead.vue?vue&type=template&id=65da9092"
import script from "./lead.vue?vue&type=script&lang=js"
export * from "./lead.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__